<template>
  <el-tooltip v-model="visible" :manual="true" :open-delay="200">
    <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''"
      @mouseenter="setVisible(true)"
      @mouseleave="setVisible(false)">
      <div class="max-w-sm max-h-500p overflow-auto">
        <div>
          <ul>
            <li>{{ group.Propietario ? 'Propietario' : '' }}</li>
            <li>{{ 'Tipo de grupo: ' + group.Tipo }}</li>
          </ul>
        </div>
      </div>
    </div>
    <span
      @mouseenter="setVisible(true)"
      @mouseleave="setVisible(false)"
      @focus="setVisible(true)"
      @blur="setVisible(false)"
    >
      <base-icon v-if="group.Propietario" name="key" size="xs"/>
      {{ group.Nombre }}
    </span>
  </el-tooltip>
</template>

<script>
export default {
  name: 'GroupTagTooltip',
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      hideTimer: null
    }
  },
  computed: {
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    }
  },
  watch: {
    visible (val) {
      if (val) {
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  beforeDestroy () {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer)
      this.hideTimer = null
    }
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    setVisible (val) {
      if (val) {
        // Al mostrar (o volver a entrar) cancelamos cualquier ocultado pendiente
        if (this.hideTimer) {
          clearTimeout(this.hideTimer)
          this.hideTimer = null
        }
        this.visible = true
      } else {
        // Mantener el tooltip 1 segundo antes de desaparecer
        if (this.hideTimer) clearTimeout(this.hideTimer)
        this.hideTimer = setTimeout(() => {
          this.visible = false
          this.hideTimer = null
        }, 400)
      }
    },
    onKeydown (event) {
      if (event.key === 'Escape' && this.visible) {
        // Cancelamos el cierre diferido y ocultamos inmediatamente
        if (this.hideTimer) {
          clearTimeout(this.hideTimer)
          this.hideTimer = null
        }
        this.visible = false
      }
    }
  },
}
</script>
